import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-device-detail',
  templateUrl: './card-device-detail.component.html',
  styleUrls: ['./card-device-detail.component.scss']
})
export class CardDeviceDetailComponent implements OnInit {

  @Input() title!: string;
  @Input() width = 500;

  constructor() { }

  ngOnInit() {
  }

}
